import { render, staticRenderFns } from "./Wagon.vue?vue&type=template&id=64d7d3f7&scoped=true"
import script from "./Wagon.vue?vue&type=script&lang=js"
export * from "./Wagon.vue?vue&type=script&lang=js"
import style0 from "./Wagon.vue?vue&type=style&index=0&id=64d7d3f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d7d3f7",
  null
  
)

export default component.exports